import React, { memo } from 'react';
import { Route, Routes } from 'react-router';

import ProjectCreateDashboard from './project-create-dashboard/ProjectCreateDashboard';
import SonarCreation from './sonar/SonarCreation';
import ResonanceCreation from './resonance/ResonanceCreation';
import ScoutCreation from './scout/ScoutCreation';
import GenieCreation from './genie/GenieCreation';
import GenieGoCreation from './genie-go/GenieGoCreation';
import Id8Creation from './id8/Id8Creation';
import CommonPage from '../../components/common-page/CommonPage';
import Activ8Creation from './activ8/Activ8Creation';

const ProjectCreate = () => {
  return (
    <CommonPage>
      <Routes>
        <Route path='/' exact element={<ProjectCreateDashboard />} />
        <Route path='/sonar' exact element={<SonarCreation />} />
        <Route path='/resonance' exact element={<ResonanceCreation />} />
        <Route path='/scout' exact element={<ScoutCreation />} />
        <Route path='/genie' exact element={<GenieCreation />} />
        <Route path='/genie-go' exact element={<GenieGoCreation />} />
        <Route path='/id8' exact element={<Id8Creation />} />
        <Route path='/activ8' exact element={<Activ8Creation />} />
      </Routes>
    </CommonPage>
  );
};

export default memo(ProjectCreate);
